import {Component, OnInit, ViewChild} from '@angular/core';
import {DxDataGridComponent} from 'devextreme-angular';
import {ToolsService} from '../../services/tools.service';
import {ModalInterface} from '../modal-basic/ModalInterface';

@Component({
  selector: 'app-modal-registros-errores',
  templateUrl: './modal-registros-errores.component.html',
  styleUrls: ['./modal-registros-errores.component.scss']
})
export class ModalRegistrosErroresComponent extends ModalInterface  implements OnInit {
  @ViewChild('dxDtgData') oDxDataGridComponent: DxDataGridComponent;
  iSelPageSize: number;
  lsPageSize: number[] = [];
  lsObservacion = [
    {value: 'NC', label: 'Cédula sin colaborador'},
    {value: 'NV', label: 'Cédula no válida'},
    {value: 'NVC', label: 'Sin cupo anual'},
    {value: 'NNV', label: 'Colaborador con nivel registrado en bago'},
    {value: 'SNV', label: 'La placa ya tiene solicitud para el periodo actual'},
    {value: 'NP', label: 'Placa no valida'},
    {value: 'PR', label: 'Placa repetida en el excel'},
    {value: 'SGC', label: 'La placa ya tiene seguro para le periodo actual'},
    {value: 'NCE', label: 'Número de celular no ingresado o no válido'},
    {value: 'TLNV', label: 'El usuario ya tiene un número de telefono de tipo bagó registrado en el sistema o en el excel'},
    {value: 'NR', label: 'El número celular se encuentra repetido en excel o ya está registrado en el sistema'},
    {value: 'LSC', label: 'El número celular no pertenecea a ningún colaborador'},
    {value: 'PC', label: 'El número celular ya tiene un plan ce celular creado para el periodo actual'},
    {value: 'LTNB', label: 'El número de celular no es una linea de tipo bagó'},
    {value: 'VPLNV', label: 'El valor del plan no es válido'},
    {value: 'TSS', label: 'La placa ya tiene seguros o solicitudes activas para el periodo actual'},
    {value: 'PLSV', label: 'La placa no pertenece a un vehículo registrado en el sistema'},
    {value: 'PLR', label: 'La placa se encuentra repetida en el archivo excel'},
    {value: 'NPL', label: 'La placa no es válida'},
    {value: 'VNM', label: 'El vehiculo no tiene la opción de mantenimiento'},
    {value: 'NNBG', label: 'El vehiculo no es nivel bagó'},
    {value: 'NUSPR', label: 'No se encontraron usuarios para aprobar el registro'},
    {value: 'ELNV', label: 'La linea esta excluída'},
  ];
  constructor(
    public tools: ToolsService,
  ) {
    super();
    this.lsPageSize = this.tools.getLimitPageSize();
    this.iSelPageSize = this.lsPageSize[1];
  }
  
  ngOnInit() {
  }
  
  mostrarColumnas(nombreCampo: string) {
    if (this.data.columnas) {
      return this.data.columnas.includes(nombreCampo);
    } else {
      return true;
    }
  }
}
